import { render } from "./StrategizeView.vue?vue&type=template&id=417bde24&scoped=true"
import script from "./StrategizeView.vue?vue&type=script&lang=js"
export * from "./StrategizeView.vue?vue&type=script&lang=js"

import "./StrategizeView.vue?vue&type=style&index=0&id=417bde24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417bde24"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QBtn,QIcon,QTooltip,QScrollArea,QSeparator,QSpinner,QRadio,QSpinnerDots,QResizeObserver,QDialog,QCard});
